import React from 'react';
import Select from "react-select";

export interface DropdownOption {
  label: string;
  value: any;
}

interface DropdownProps {
    options: DropdownOption[];
    // Callback function to be called when an option is selected.
    // It receives the selected option as an argument.
    onSelect: (selectedOption: DropdownOption | null) => void;
    text: string;
    clearable?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({ options, onSelect, text, clearable = false }) => {

    const dropdownStyles = {
        singleValue: (styles: any) => {
          return {
            ...styles,
            color: "#fff",
          };
        },
    
        placeholder: (styles: any) => {
          return {
            ...styles,
            color: "rgba(255, 255, 255, 0.6)",
          };
        },
    
        input: (styles: any) => {
          return {
            ...styles,
            caretColor: "white",
            color: "white",
          };
        },
    
        control: (styles: any) => {
          return {
            ...styles,
            background: "linear-gradient(120deg, #23263a 60%, #1a1c28 100%)",
            outline: "none",
            caretColor: "white",
            color: "white",
            boxShadow: "0 0 4px 0.5px #00eaff",
            border: "2px solid #5fa8e6",
            borderRadius: "8px",
            "&:hover": {
              boxShadow: "0 0 6px 1px #00eaff",
            },
          };
        },
    
        menu: (styles: any) => {
          return {
            ...styles,
            background: "linear-gradient(120deg, #23263a 60%, #1a1c28 100%)",
            border: "2px solid #5fa8e6",
            borderRadius: "8px",
            zIndex: "999",
            position: "absolute",
            boxShadow: "0 0 4px 0.5px #00eaff",
          };
        },        option: (styles: any) => {
          return {
            ...styles,
            background: "linear-gradient(120deg, #23263a 60%, #1a1c28 100%)",
            color: "#fff",
            "&:hover": {
              background: "linear-gradient(120deg, #2d3145 60%, #232632 100%)",
              boxShadow: "inset 0 0 8px rgba(0, 234, 255, 0.3)",
            },
          };
        },
      };

  return (
    <Select
      placeholder={text}
      onChange={(selectedOption) => onSelect(selectedOption as DropdownOption)}
      options={options}
      styles={dropdownStyles}
      isSearchable={false}
      isClearable={clearable}
    />
  );
};

export default Dropdown;
